import React, { PropsWithChildren } from 'react';

import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';

import Button from '../Button';

type PropType = PropsWithChildren<
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
>;

export const DotButton: React.FC<PropType> = (props) => {
  const { children, ...restProps } = props;

  return (
    <button type="button" {...restProps}>
      {children}
    </button>
  );
};

export const PrevButton: React.FC<PropType> = (props) => {
  const { ...restProps } = props;
  return (
    <Button
      className="embla__button embla__button--prev"
      intent={'quarternary'}
      icon={BsArrowLeft}
      left
      type="button"
      {...restProps}
    />
  );
};

export const NextButton: React.FC<PropType> = (props) => {
  const { ...restProps } = props;

  return (
    <Button
      className="embla__button embla__button--next"
      intent={'quarternary'}
      icon={BsArrowRight}
      left
      type="button"
      {...restProps}
    />
  );
};
